import { classNames } from "@circle-react/helpers/twMergeWithCN";

import { CoverImageRaw } from "./CoverImageRaw";
import type { CoverImageInterface } from "./types";

export const Confirmation = ({
  paywall,
  coverImageClassName,
  eventImageClassName,
}: CoverImageInterface) => (
  <CoverImageRaw
    paywall={paywall}
    coverImageClassName={classNames(
      "w-[71px] h-[41px] rounded-[0.416rem]",
      coverImageClassName,
    )}
    eventImageClassName={eventImageClassName}
  />
);
